@if (details$ | async; as details) {
  <div class="grid grid-cols-1 gap-3 xl:grid-cols-2">
    <app-details-view label="Identyfikator">
      @if (isNotNil(details.id)) {
        {{ details.id }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Nazwa">
      @if (isNotNil(details.name)) {
        {{ details.name }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Cena">
      @if (isNotNil(details.price)) {
        <app-currency [amount]="details.price" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Slug">
      @if (isNotNil(details.slug)) {
        {{ details.slug }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Data utworzenia">
      @if (isNotNil(details.createdAt)) {
        <app-date [date]="details.createdAt" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Data pierwszej publikacji">
      @if (isNotNil(details.publishedAt)) {
        <app-date [date]="details.publishedAt" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Status">
      @if (isNotNil(details.status)) {
        <app-admin-box-status [status]="details.status" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Hasło">
      @if (isNotNil(details.password)) {
        {{ details.password }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Marka kosmetyczna">
      @if (isNotNil(details.cosmeticBrandName)) {
        {{ details.cosmeticBrandName }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Kategoria boxa">
      @if (isNotNil(details.boxCategoryName)) {
        {{ details.boxCategoryName }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Odpowiednik magazynowy">
      @if (isNotNil(details.warehouseProductName)) {
        {{ details.warehouseProductName }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Maksymalna ilość sztuk w zamówieniu">
      @if (isNotNil(details.maxQuantityPerOrder)) {
        {{ details.maxQuantityPerOrder }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Dostępna ilość do kupienia">
      @if (isNotNil(details.availableQuantity)) {
        {{ details.availableQuantity }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Edycja aktualnie w sprzedaży">
      @if (isNotNil(details.currentEdition)) {
        {{ details.currentEdition | boolean }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Adres URL do podglądu zawartości">
      @if (isNotNil(details.contentPreviewUrl)) {
        <app-external-link [link]="details.contentPreviewUrl">
          {{ details.contentPreviewUrl }}
        </app-external-link>
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Adres URL do boxa w sklepie">
      @if (isNotNil(details.shopPreviewUrl)) {
        <app-admin-box-link
          [status]="details.status"
          [slug]="details.slug" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <!--    <div class="col-span-2">-->
    <!--      <app-details-view label="Atrybuty boxa">-->
    <!--        @if (shouldShowAttributesAccordions(details.attributes)) {-->
    <!--          <div class="rounded-lg border p-4 border-gray-200">-->
    <!--            <p-accordion [multiple]="true">-->
    <!--              @for (-->
    <!--                attribute of details.attributes;-->
    <!--                track attribute.id;-->
    <!--                let index = $index-->
    <!--              ) {-->
    <!--                <p-accordion-panel [value]="index">-->
    <!--                  <p-accordion-header>-->
    <!--                    <div class="flex items-center gap-2 text-sm text-gray-400">-->
    <!--                      <span>#{{ index + 1 }}</span>-->
    <!--                      <span>{{ attribute.label }}</span>-->
    <!--                    </div>-->
    <!--                  </p-accordion-header>-->

    <!--                  <p-accordion-content>-->
    <!--                    <p-accordion-content>-->
    <!--                      <app-summernote-html-preview [html]="attribute.content" />-->
    <!--                    </p-accordion-content>-->
    <!--                  </p-accordion-content>-->
    <!--                </p-accordion-panel>-->
    <!--              }-->
    <!--            </p-accordion>-->
    <!--          </div>-->
    <!--        } @else {-->
    <!--          <app-no-data />-->
    <!--        }-->
    <!--      </app-details-view>-->
    <!--    </div>-->

    <div class="xl:col-span-2">
      <app-details-view label="Kosmetyki w boxie">
        @if (isNotEmptyArray(details.cosmetics)) {
          <app-admin-box-cosmetics-grid
            [items]="details.cosmetics"
            [isReadonly]="true" />
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>

    <div class="xl:col-span-2">
      <app-details-view label="Charakterystyka boxa">
        @if (shouldShowCharacteristicsAccordions(details.characteristics)) {
          <div class="rounded-lg border border-gray-200 p-4">
            <p-accordion [multiple]="true">
              @for (
                characteristic of details.characteristics;
                track characteristic.id;
                let index = $index
              ) {
                <p-accordion-panel [value]="index">
                  <p-accordion-header>
                    <div class="flex items-center gap-2 text-sm text-gray-400">
                      <span>#{{ index + 1 }}</span>
                      <span>{{ characteristic.label }}</span>
                    </div>
                  </p-accordion-header>

                  <p-accordion-content>
                    <app-summernote-html-preview
                      [html]="characteristic.content" />
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          </div>
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>
  </div>

  <div class="mt-3 grid grid-cols-1 gap-3 xl:grid-cols-2">
    <app-details-view label="Zdjęcie główne">
      @if (isNotNil(details.featuredFile)) {
        <app-multimedia-galleria-thumbnails
          [files]="[details.featuredFile]"
          [fetchMultimediaDetailsFn]="fetchMultimediaDetailsFn" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Symbol boxa kosmetycznego">
      @if (isNotNil(details.symbolFile)) {
        <app-multimedia-galleria-thumbnails
          [files]="[details.symbolFile]"
          [fetchMultimediaDetailsFn]="fetchMultimediaDetailsFn" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Zdjęcie podglądu zawartości boxa">
      @if (isNotNil(details.illustrationFile)) {
        <app-multimedia-galleria-thumbnails
          [files]="[details.illustrationFile]"
          [fetchMultimediaDetailsFn]="fetchMultimediaDetailsFn" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Galeria">
      @if (isNotEmptyArray(details.files)) {
        <app-multimedia-galleria-thumbnails
          [files]="details.files"
          [fetchMultimediaDetailsFn]="fetchMultimediaDetailsFn" />
      } @else {
        <app-no-data />
      }
    </app-details-view>
  </div>

  <div class="mt-3 rounded-sm border border-gray-200 p-4">
    <h5>Historia zmian dostępnej ilości</h5>

    <p-divider appPrimengDivider />

    <app-admin-box-quantity-history-list [id]="details.id" />
  </div>
} @else {
  <app-spinner-filled />
}
